export function currentUserQueryKey(bearerToken?: string) {
  return ['users', 'getCurrentUser', bearerToken] as const
}
